module.exports = __webpack_public_path__ + "img/portalhomeempty.901aee26.png";